import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminFeedbackDetailPage, type AdminFeedbackDetailPageProps } from '../ui/admin/AdminFeedbackDetailPage';

export function AdminFeedbackDetailPageContainer(props: AdminFeedbackDetailPageProps) {
  return <AdminFeedbackDetailPage {...props} />;
}

export function mountAdminFeedbackDetailPage(
  container: HTMLElement,
  props: AdminFeedbackDetailPageProps
) {
  const root = createRoot(container);
  root.render(<AdminFeedbackDetailPageContainer {...props} />);
  return root;
}

export default AdminFeedbackDetailPageContainer;
